import { Box, Grid2, Typography } from "@mui/material";
import React from "react";
import ViewApprovers from "./ViewTender/ViewApprovers";

const AwardedPDF = ({ tender, awarded, groupedWorkItems, groupedData }) => {
  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const [date, time] = dateString.split("T");
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year} ${time}`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  };
  return (
    <>
      {tender && (
        <div>
          <Typography className="form-title">
            Summary of Tender Process
          </Typography>
          <Typography>
            <span style={{ fontWeight: "bold" }}>Tender ID:</span>{" "}
            {tender.tenderId}
          </Typography>
          <Typography>
            <span style={{ fontWeight: "bold" }}>Tender Publish Date:</span>{" "}
            {formatDate(tender.tenderPublishDate)}
          </Typography>
          <Typography>
            <span style={{ fontWeight: "bold" }}>Estimate Bid Value:</span>{" "}
            {tender.bidValue}
          </Typography>
          <Typography>
            <span style={{ fontWeight: "bold" }}>Bid Opening Date:</span>{" "}
            {formatDateTime(tender.bidOpeningDate)}
          </Typography>
          <Typography>
            <span style={{ fontWeight: "bold" }}>Title:</span> {tender.title}
          </Typography>
          <Typography>
            <span style={{ fontWeight: "bold" }}>Short Description:</span>{" "}
            {tender.shortDesc}
          </Typography>
          <Typography className="form-title">
            Item Group wise summary Commercial Comparison
          </Typography>
          <table
            style={{
              borderCollapse: "collapse",
              minWidth: "100%",
              textAlign: "center",
              border: "1px solid #ccc",
            }}
          >
            <thead>
              {/* First Row: Vendor Names */}
              <tr>
                <th
                  rowSpan={2}
                  style={{
                    padding: "9px",
                    borderBottom: "1px solid #ccc",
                    borderRight: "1px solid #ccc",
                  }}
                >
                  Item Group
                </th>
                {Object.entries(groupedData).map(([vendor, bids]) => {
                  const filteredBids =
                    bids.length > 1
                      ? [bids[0], bids[bids.length - 1]]
                      : [bids[0]];
                  return (
                    <th
                      key={vendor}
                      colSpan={filteredBids.length}
                      style={{
                        padding: "9px",
                        borderBottom: "1px solid #ccc",
                        borderRight: "1px solid #ccc",
                      }}
                    >
                      {vendor}
                    </th>
                  );
                })}
              </tr>

              {/* Second Row: Bid Numbers */}
              <tr>
                {Object.entries(groupedData).flatMap(([vendor, bids]) => {
                  const filteredBids =
                    bids.length > 1
                      ? [bids[0], bids[bids.length - 1]]
                      : [bids[0]];
                  return filteredBids.map((_, i) => (
                    <th
                      key={`${vendor}-bid-${i}`}
                      style={{
                        padding: "8px",
                        borderBottom: "1px solid #ccc",
                        borderRight: "1px solid #ccc",
                      }}
                    >
                      {i === 0 ? "Initial Bid" : "Final Bid"}
                    </th>
                  ));
                })}
              </tr>
            </thead>

            <tbody>
              {Object.entries(groupedWorkItems).map(
                ([section, items], sectionIndex) => (
                  <React.Fragment key={sectionIndex}>
                    {/* Section Title Row */}
                    <tr style={{ fontWeight: "bold" }}>
                      <td
                        style={{
                          textAlign: "left",
                          padding: "10px",
                          borderRight: "1px solid #ccc",
                        }}
                      >
                        Section: {section}
                      </td>
                      {Object.entries(groupedData).flatMap(([vendor, bids]) => {
                        const filteredBids =
                          bids.length > 1
                            ? [bids[0], bids[bids.length - 1]]
                            : [bids[0]];
                        return filteredBids.map((bid, i) => {
                          const sectionItems = bid.bidWorkItems.filter((bi) =>
                            items.find((wi) => wi.itemName === bi.itemName)
                          );
                          const sectionTotal = sectionItems.reduce(
                            (sum, si) => sum + ((si.quantity * si.rate) || 0),
                            0
                          );
                          return (
                            <td
                              key={`${vendor}-sectionTotal-${i}-${sectionIndex}`}
                              style={{
                                textAlign: "right",
                                padding: "10px",
                                borderRight: "1px solid #ccc",
                              }}
                            >
                              {new Intl.NumberFormat("en-IN", {
                                style: "decimal",
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }).format(sectionTotal)}
                            </td>
                          );
                        });
                      })}
                    </tr>
                  </React.Fragment>
                )
              )}

              {/* Grand Total Row */}
              <tr style={{ fontWeight: "bold", borderTop: "2px solid #000" }}>
                <td
                  style={{
                    textAlign: "right",
                    padding: "10px",
                    borderRight: "1px solid #ccc",
                    borderBottom: "1px solid #ccc",
                  }}
                >
                  Grand Total (₹)
                </td>
                {Object.entries(groupedData).flatMap(([vendor, bids]) => {
                  const filteredBids =
                    bids.length > 1
                      ? [bids[0], bids[bids.length - 1]]
                      : [bids[0]];
                  return filteredBids.map((bid, i) => {
                    const grandTotal = bid.bidWorkItems.reduce(
                      (acc, item) => acc + (item.quantity * item.rate || 0),
                      0
                    );
                    return (
                      <td
                        key={`${vendor}-grand-${i}`}
                        style={{
                          textAlign: "right",
                          padding: "10px",
                          borderRight: "1px solid #ccc",
                        }}
                      >
                        {new Intl.NumberFormat("en-IN", {
                          style: "decimal",
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }).format(grandTotal)}
                      </td>
                    );
                  });
                })}
              </tr>

              {/* Current Status Row */}
              <tr>
                <td
                  style={{ fontWeight: "bold", borderRight: "1px solid #ccc" }}
                >
                  Current Status
                </td>
                {Object.entries(groupedData).flatMap(([vendor, bids]) => {
                  const filteredBids =
                    bids.length > 1
                      ? [bids[0], bids[bids.length - 1]]
                      : [bids[0]];
                  return filteredBids.map((bid, i) => (
                    <td
                      key={`${vendor}-status-${i}`}
                      style={{
                        borderTop: "1px solid #ccc",
                        height: "40px",
                        borderRight: "1px solid #ccc",
                      }}
                    >
                      {bid.bidStatus}
                    </td>
                  ));
                })}
              </tr>
            </tbody>
          </table>

          <Typography className="form-title">Awarded</Typography>
          {awarded ? (
            <Box
              className="dashboard-container"
              px={10}
              key={awarded.vendor.vendorId}
            >
              <Typography sx={{ fontWeight: "bold" }}>
                Vendor: {awarded.vendor.name}
              </Typography>
              <table
                border={1}
                style={{ width: "100%", borderCollapse: "collapse" }}
              >
                <thead>
                  <tr>
                    <th style={{ padding: "20px", textAlign: "left" }}>
                      Awarded
                    </th>
                    <th style={{ padding: "20px", textAlign: "center" }}>
                      Total Amount (₹)
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ padding: "20px", fontWeight: "bold" }}>
                      {awarded.vendor.name} ({awarded.vendor.firmName})
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                        fontWeight: "bold",
                        backgroundColor: "#e0f7fa",
                      }}
                    >
                      {awarded.bidWorkItems
                        .filter((bw) => awarded.bidStatus === "AWARDED")
                        .reduce((sum, bw) => sum + (bw.quantity * bw.rate || 0), 0)
                        .toFixed(2)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </Box>
          ) : null}
          <Box className="dashboard-container">
            <Typography variant="h6">Tender Approved By:</Typography>
            <Grid2 container sx={{ width: 600 }}>
              {tender &&
                tender.approvers.map((approver, i) => (
                  <React.Fragment key={i}>
                    {approver?.approver?.userRoleName === "PURCHASE_HEAD" && (
                      <table
                        border={1}
                        style={{ borderCollapse: "collapse", width: "100%" }}
                      >
                        <thead>
                          <th style={{width: 200}}>User Role</th>
                          <th style={{width: 200}}>User Name</th>
                          <th style={{width: 200}}>Email ID</th>
                        </thead>
                        <tbody>
                          <tr>
                            <td
                              style={{
                                padding: "8px",
                                width: "50%",
                              }}
                            >
                              {approver?.approver?.userRoleName.replace("_", " ")}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                width: "50%",
                              }}
                            >
                              {approver?.approver?.name}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                width: "50%",
                              }}
                            >
                              {approver?.approver?.email}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    )}
                  </React.Fragment>
                ))}
            </Grid2>
            <Typography variant="h6" mt={5}>
              Tender Purchase Amount Received Approved By:
            </Typography>
            <Grid2 container sx={{ width: 600 }}>
              {tender &&
                tender.approvers.map((approver, i) => (
                  <React.Fragment key={i}>
                    {tender?.getBank !== null && tender?.getBank === "ARG" ? (
                      <table
                        border={1}
                        style={{ borderCollapse: "collapse", width: "100%" }}
                      >
                        <thead>
                          <th>User Role</th>
                          <th>User Name</th>
                        </thead>
                        <tbody>
                          <tr>
                            <td
                              style={{
                                padding: "8px",
                                width: "50%",
                              }}
                            >
                              Admin
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                width: "50%",
                              }}
                            >
                              ARG Supply Tech
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    ) : (
                      approver?.approver?.userRoleName === "FINANCE_HEAD" && (
                        <table
                          border={1}
                          style={{ borderCollapse: "collapse", width: "100%" }}
                        >
                          <thead>
                            <th style={{width: 200}}>User Role</th>
                            <th style={{width: 200}}>User Name</th>
                            <th style={{width: 200}}>Email ID</th>
                          </thead>
                          <tbody>
                            <tr>
                              <td
                                style={{
                                  padding: "8px",
                                  width: "50%",
                                }}
                              >
                                {approver?.approver?.userRoleName.replace("_", " ")}
                              </td>
                              <td
                                style={{
                                  padding: "8px",
                                  width: "50%",
                                }}
                              >
                                {approver.approver.name}
                              </td>
                              <td
                                style={{
                                  padding: "8px",
                                  width: "50%",
                                }}
                              >
                                {approver.approver.email}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      )
                    )}
                  </React.Fragment>
                ))}
            </Grid2>
            <Typography variant="h6" mt={5}>
              Vendor Qualification Approved By:
            </Typography>
            <Grid2 container sx={{ width: 600 }}>
              <table
                border={1}
                style={{ borderCollapse: "collapse", width: "100%" }}
              >
                <thead>
                  <th style={{width: 200}}>User Role</th>
                  <th style={{width: 200}}>User Name</th>
                  <th style={{width: 200}}>Email ID</th>
                </thead>
                <tbody>
                  <tr>
                    <td
                      style={{
                        padding: "8px",
                        width: "50%",
                      }}
                    >
                      BUYER
                    </td>
                    <td
                      style={{
                        padding: "8px",
                        width: "50%",
                      }}
                    >
                      {tender.orgUser.name}
                    </td>
                    <td
                      style={{
                        padding: "8px",
                        width: "50%",
                      }}
                    >
                      {tender.orgUser.email}
                    </td>
                  </tr>
                  {tender &&
                    tender.approvers.map((approver, i) => (
                      <React.Fragment key={i}>
                        {approver?.approver?.userRoleName !==
                          "FINANCE_HEAD" && (
                          <tr>
                            <td
                              style={{
                                padding: "8px",
                                width: "50%",
                              }}
                            >
                              {approver?.approver?.userRoleName.replace("_", " ")}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                width: "50%",
                              }}
                            >
                              {approver.approver.name}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                width: "50%",
                              }}
                            >
                              {approver.approver.email}
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    ))}
                </tbody>
              </table>
            </Grid2>
            <Typography variant="h6" mt={5}>EMD Received Approved By:</Typography>
            <Grid2 container sx={{ width: 600 }}>
              {tender &&
                tender.approvers.map((approver, i) => (
                  <React.Fragment key={i}>
                    {approver?.approver?.userRoleName === "FINANCE_HEAD" && (
                      <table
                        border={1}
                        style={{ borderCollapse: "collapse", width: "100%" }}
                      >
                        <thead>
                          <th style={{width: 200}}>User Role</th>
                          <th style={{width: 200}}>User Name</th>
                          <th style={{width: 200}}>Email ID</th>
                        </thead>
                        <tbody>
                          <tr>
                            <td
                              style={{
                                padding: "8px",
                                width: "50%",
                              }}
                            >
                              {approver?.approver?.userRoleName.replace("_", " ")}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                width: "50%",
                              }}
                            >
                              {approver.approver.name}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                width: "50%",
                              }}
                            >
                              {approver.approver.email}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    )}
                  </React.Fragment>
                ))}
            </Grid2>
            <Typography variant="h6" mt={5}>Technical Evaluation Done By:</Typography>
            <Grid2 container sx={{ width: 600 }}>
              {tender &&
                tender.approvers.map((approver, i) => (
                  <React.Fragment key={i}>
                    {approver?.approver?.userRoleName === "TECHNICAL_HEAD" && (
                      <table
                        border={1}
                        style={{ borderCollapse: "collapse", width: "100%" }}
                      >
                        <thead>
                          <th style={{width: 200}}>User Role</th>
                          <th style={{width: 200}}>User Name</th>
                          <th style={{width: 200}}>Email ID</th>
                        </thead>
                        <tbody>
                          <tr>
                            <td
                              style={{
                                padding: "8px",
                                width: "50%",
                              }}
                            >
                              {approver?.approver?.userRoleName.replace("_", " ")}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                width: "50%",
                              }}
                            >
                              {approver.approver.name}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                width: "50%",
                              }}
                            >
                              {approver.approver.email}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    )}
                  </React.Fragment>
                ))}
            </Grid2>
            <Typography variant="h6" mt={5}>Simultaneous Bid Openers:</Typography>
            <Grid2 container sx={{ width: 600 }}>
              {/* <Grid2
                size={{ xs: 12, sm: 12 }}
                className="preview-grid"
                sx={{
                  borderTop: "1px solid #000",
                  borderRight: "1px solid #000",
                }}
              >
                Total Bid Openers:{" "}
                {tender.openers ? tender.openers[0].noOfOpeners : 0}
              </Grid2> */}
                      <table
                        border={1}
                        style={{ borderCollapse: "collapse", width: "100%" }}
                      >
                        <thead>
                          <th style={{width: 200}}>User Role</th>
                          <th style={{width: 200}}>User Name</th>
                          <th style={{width: 200}}>Email ID</th>
                        </thead>
                        <tbody>
              {tender
                ? tender.openers.map((opener, i) => (
                    <React.Fragment key={i}>
                          <tr>
                            <td
                              style={{
                                padding: "8px",
                                width: "50%",
                              }}
                            >
                              {opener?.opener?.userRoleName.replace("_", " ")}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                width: "50%",
                              }}
                            >
                              {opener.opener.name}
                            </td>
                            <td
                              style={{
                                padding: "8px",
                                width: "50%",
                              }}
                            >
                              {opener.opener.email}
                            </td>
                          </tr>
                    </React.Fragment>
                  ))
                  : null}
                  </tbody>
                </table>
            </Grid2>
            <Typography variant="h6" mt={5}>Final Approvers:</Typography>
            <Grid2 container sx={{ width: 600 }}>
              {tender &&
                tender.tenderAwardees.map((awardee, i) => (
                  <React.Fragment key={i}>
                    <table
                      border={1}
                      style={{ borderCollapse: "collapse", width: "100%" }}
                    >
                      <thead>
                        <th style={{width: 200}}>User Role</th>
                        <th style={{width: 200}}>User Name</th>
                        <th style={{width: 200}}>Email ID</th>
                      </thead>
                      <tbody>
                        <tr>
                          <td
                            style={{
                              padding: "8px",
                              width: "50%",
                            }}
                          >
                            {awardee?.awardee1?.userRoleName.replace("_"," ") || "N/A"}
                          </td>
                          <td
                            style={{
                              padding: "8px",
                              width: "50%",
                            }}
                          >
                            {awardee?.awardee1?.name || "N/A"}
                          </td>
                          <td
                            style={{
                              padding: "8px",
                              width: "50%",
                            }}
                          >
                            {awardee?.awardee1?.email || "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              padding: "8px",
                              width: "50%",
                            }}
                          >
                            {awardee?.awardee2?.userRoleName.replace("_"," ")}
                          </td>
                          <td
                            style={{
                              padding: "8px",
                              width: "50%",
                            }}
                          >
                            {awardee?.awardee2?.name}
                          </td>
                          <td
                            style={{
                              padding: "8px",
                              width: "50%",
                            }}
                          >
                            {awardee?.awardee2?.email}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </React.Fragment>
                ))}
            </Grid2>
          </Box>
        </div>
      )}
    </>
  );
};

export default AwardedPDF;
